const isProd = window.location.hostname === 'uk-air.defra.gov.uk';
const MAP_OPTIONS = {
  extent: {
    xmin: -470240,
    ymin: -322320,
    xmax: 929410,
    ymax: 1265180,
    spatialReference: { wkid: 27700 },
  },
  zoom: 7,
};

const ARCGIS_ROOT_URL = isProd
  ? 'https://ukair.maps.rcdo.co.uk'
  : 'https://ukair.maps.staging.rcdo.co.uk';
const ARCGIS_ENV_URL = `${ARCGIS_ROOT_URL}/ukairserver`;

const ARCGIS_SERVICES_ROOT_URL = ARCGIS_ENV_URL + '/rest/services/';
const ARCGIS_SERVICES = {
  _VERSION: '1.0',
  GIS_SERVER: {
    FEATURES: "Hosted/Smoke_Control_Area_Boundaries_and_Exemptions/FeatureServer/0",
    LA_URL:
      ARCGIS_SERVICES_ROOT_URL + 'Hosted/Local_Authorities/FeatureServer/0',
    GP: {
      LIST_OF_SERVICE_URL:
        ARCGIS_SERVICES_ROOT_URL +
        'geotools/sca_services_list_v1/GPServer/get_services_to_display',
      SERVICE_INFO_URL:
        ARCGIS_SERVICES_ROOT_URL +
        'geotools/sca_download_v2/GPServer/get_download_url',
      DOWNLOAD_LAYER_URL:
        ARCGIS_SERVICES_ROOT_URL +
        'System/SpatialAnalysisTools/GPServer/ExtractData',
      DOWNLOAD_LAYER_INFO:
        ARCGIS_SERVICES_ROOT_URL +
        'geotools/sca_download_v2/GPServer/get_download_url',
      TOKEN_INFO_URL:
        ARCGIS_SERVICES_ROOT_URL +
        'geotools/ukair_get_hash_v1/GPServer/get_hash',
      POPUP_INFO_URL:
        ARCGIS_SERVICES_ROOT_URL + 'geotools/sca_popup_v1/GPServer/get_content',
    },
    NI: {
      OS_GREY: ARCGIS_SERVICES_ROOT_URL + 'Hosted/osgrey/FeatureServer',
      OS_OPENCARTO:
        ARCGIS_SERVICES_ROOT_URL + 'Hosted/ospencarto/FeatureServer',
    },
  },
};

const FEATURES_URL = ARCGIS_SERVICES_ROOT_URL + ARCGIS_SERVICES.GIS_SERVER.FEATURES

const DOWNLOAD_FILE_TYPES = [{ name: 'Shapefile', value: 'ShapeFile' }];
const QUERY_DATA_BUTTON_ACTION = {
  title: 'Get Data',
  id: 'get-data',
  className: 'esri-icon-query-data',
};
const ACTIVE_HIGHLIGHT_LINE_ID = 'active_highlight';
const DEFAULT_OPACITY = 0.7;
const DEFAULT_POPUP_TEMPLATE_ITEMS = {
  title: 'Attributes of active layers',
};
const APP_SETTINGS = Object.freeze(ARCGIS_SERVICES);

export {
  ARCGIS_ROOT_URL,
  APP_SETTINGS,
  ARCGIS_SERVICES_ROOT_URL,
  MAP_OPTIONS,
  DOWNLOAD_FILE_TYPES,
  QUERY_DATA_BUTTON_ACTION,
  ACTIVE_HIGHLIGHT_LINE_ID,
  DEFAULT_OPACITY,
  DEFAULT_POPUP_TEMPLATE_ITEMS,
  FEATURES_URL
};
